import { Button, Tooltip } from "@nextui-org/react";
import { TooltipIcon } from '~/constants/icon';

interface InfoTooltipProps {
    content: string;
    className?: string;
}

export function InfoTooltip({ content, className = "max-w-[300px]" }: InfoTooltipProps) {
    return (
        <Tooltip
            content={content}
            className={className}
            classNames={{
                content: "text-sm text-white !bg-[#1f1f1f] !border-none",
                arrow: "!bg-[#1f1f1f]",
            }}
        >
            <Button isIconOnly size="sm" variant="light" className="min-w-0 w-4 h-4 p-0">
                <TooltipIcon />
            </Button>
        </Tooltip>
    );
}